import styled from "styled-components";

export const StyledPaymentBlock = styled.div<{ $withBorderBottom: boolean }>`
    display: flex;
    flex-direction: row;

    .vertical-date {
        display: flex;
        flex-direction: column;
        text-align: center;

        .date {
            font-size: var(--size-14);
            line-height: 18px;
            color: var(--color-grey-900);
        }

        .month {
            font-size: var(--size-10);
            line-height: 18px;
            color: var(--color-secondary);
            text-transform: uppercase;
        }

        .year {
            font-size: var(--size-10);
            line-height: 16px;
            color: var(--color-grey-800);
        }
    }

    .beneficiary-block {
        display: flex;
        flex: 1;
        flex-direction: column;
        padding-right: 12px;
        padding-left: 12px;

        .beneficiary {
            font-size: var(--size-16);
            line-height: 24px;
            color: var(--color-grey-900);
        }

        .bank-account {
            margin-top: 4px;
            font-size: var(--size-14);
            line-height: 24px;
            color: var(--color-grey-800);
        }
    }

    .amount {
        align-self: center;
        font-size: var(--size-16);
        color: var(--color-grey-900);
    }

    ${(props) =>
        props.$withBorderBottom &&
        `
    padding-top: 8px;
    margin-top: 8px;
    border-top: 1px solid var(--color-grey-600);
  `}
`;
